import { api } from "../../../api";

const root = process.env.REACT_APP_BACKEND_FINANCE_URL;
const route = api(root);
const token = JSON.parse(localStorage.getItem("user"))?.userToken;

const CooperativeManagementServices = {
  async getCooperativeReviewer({ pageSize, pageNumber, approvalStatus }) {
    try {
      let { data } = await route.get(
        `/cooperativemanagement/reviewcooperativerequestquery?PageSize=${pageSize}&PageNumber=${pageNumber}&ApprovalStatus=${approvalStatus}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      console.log({ getCooperativeReviewer: data });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
};

export default CooperativeManagementServices;
